import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { useSystemConfigNumber } from "@/hooks/use-system-config";
import {
  DEFAULT_REPORTING_RECONCILIATION_DAY,
  formatReportingReconciliationStatus,
  getReportingReconciliationPeriod,
  reconciledMonthForYear,
} from "@/lib/reporting-reconciliation";

export function useReportingReconciliation(year = new Date().getFullYear()) {
  const enabled = useFeatureFlag("feature_kpi_reconciliation");
  const config = useSystemConfigNumber("reporting_reconciliation_day");
  const period = getReportingReconciliationPeriod(
    new Date(),
    config.data ?? DEFAULT_REPORTING_RECONCILIATION_DAY,
  );

  return {
    enabled,
    isLoading: config.isLoading,
    period,
    reconciledThroughMonth: reconciledMonthForYear(period, year),
    statusText: formatReportingReconciliationStatus(period),
  };
}

